import {
    VAT_ONCHANGE
} from '../Actions/Vat.action';

const DEFAULT_STATE = {
    value: false
};

export const vat = (state = DEFAULT_STATE, action) => {
    const { type, payload } = action;
    
    switch (type) {     
        case VAT_ONCHANGE:
            return {
                ...              
                payload
            };
            
        default:
            return state;
    }
};
